const SDK_VERSION = '8.17.0';

export { SDK_VERSION };
//# sourceMappingURL=version.js.map
